<template>
  <div class="wrapper">
    <page-banner></page-banner>
    <div class="main">
      <div class="breadcrumb">
        <svg t="1702547791177" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1445" width="64" height="64"><path d="M512 341.333333L170.666667 512v455.111111h398.222222v-227.555555h113.777778v227.555555h170.666666V512L512 341.333333z" fill="#515151" p-id="1446"></path><path d="M910.222222 306.631111V113.777778h-113.777778v129.706666L512 85.333333l-512 284.444445L51.2 455.111111 512 204.8l460.8 256 51.2-91.022222-113.777778-63.146667z" fill="#515151" p-id="1447"></path></svg>
        <span class="clickable" @click="goToHome">官网首页</span>
        <span>&gt;</span>
        <span class="clickable" @click="goToList">新闻列表</span>
        <span>&gt;</span>
        <span>新闻详情</span>
      </div>
      <div class="title">
        <div class="text">{{ detail.title }}</div>
        <div class="time">{{ detail.time }}</div>
      </div>
      <div class="content">
        <div class="text" v-html="detail.content"></div>
      </div>
    </div>
    <module-footer></module-footer>
  </div>
</template>

<script>
import PageBanner from '../components/pageBanner'
import ModuleFooter from '../components/footer'

import { getNewsDetail } from '@/api/system.api.js'

export default {
  components: {
    PageBanner,
    ModuleFooter,
  },
  data() {
    return {
      detail: {},
    }
  },
  computed: {
    query() {
      return this.$route.query ? this.$route.query : {}
    },
    newsID() {
      return this.query.id
    }
  },
  created() {
    document.documentElement.scrollTop = 0
    this.getNewsDetail()
  },
  methods: {
    getNewsDetail() {
      if (!this.newsID) this.$router.push({ name: 'Home' })
      getNewsDetail({}, this.newsID)
        .then((res) => {
          if (res.data.id) {
            this.detail = {
              id: res.data.id,
              title: res.data.title,
              time: new Date(res.data.createtime * 1000).toLocaleDateString('zh-cn'),
              content: res.data.content,
            }
          } else {
            this.$router.push({ name: 'Home' })
          }
        })
    },
    // 回到首页
    goToHome() {
      this.$router.push({ name: 'Home' })
    },
    // 回到列表页
    goToList() {
      this.$router.push({ name: 'List' })
    },
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  max-width: 1920px;
  min-width: 1600px;
  width: 100%;
  background: #e2f3fb;
}

.main {
  padding-bottom: 198px;
  min-height: calc(100vh - 613px);
}

.breadcrumb {
  display: flex;
  margin: 21px auto 0;
  width: 1000px;
  font-size: 16px;
  color: #515151;

  svg {
    margin-right: 8px;
    width: 24px;
    height: 24px;
  }

  span {
    margin-right: 6px;
  }

  .clickable {
    cursor: pointer;
  }
}

.title {
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1000px;
  min-height: 156px;

  .text {
    margin-top: 58px;
    margin-bottom: 12px;
    text-align: center;
    font-size: 30px;
    font-weight: bold;
    color: #3a3a3a;
  }

  .time {
    margin-bottom: 15px;
    font-size: 16px;
    color: #8e8e8e;
  }
}

.content {
  margin: 0 auto;
  padding-top: 40px;
  width: 1000px;
  border-top: 1px solid #959595;

  .text {
    line-height: 28px;
    font-size: 16px;
    color: #3a3a3a;
    white-space: pre-wrap;
    word-break: break-all;
  }

  ::v-deep video {
    margin: 4vw auto;
    width: 100%;
  }
  
  ::v-deep img {
    display: block;
    margin: 30px auto;
    max-width: 100%;
  }
}
</style>